import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { DateUtil } from "../util/dateUtil";
import { NGaugeService } from "./shared/ngauge.service";
import { AuthService } from "./shared/auth.service";
import { UserService } from "./user.service";

@Injectable()
export class SalesActivityService {
  formValues: any;
  userInfo: any;
  private salesActivitySub = new BehaviorSubject<any>(null);
  salesActivity$ = this.salesActivitySub.asObservable();
  changeOption: string;

  publishSalesActivity(salesActivity) {
    this.salesActivitySub.next(salesActivity);
  }

  constructor(
    private httpClient: HttpClient,
    private authService: AuthService,
    private ngaugeService: NGaugeService
  ) {}

  // Home Page Calendar - to get the activities for the selected month //
  getSalesActivities(startDate, endDate, property) {
    let httpParams = new HttpParams();
    let sid=sessionStorage.getItem('sid')
    httpParams = httpParams.append('startDate', startDate).append('endDate', endDate).append('property', property).append('SID',sid);
    return this.httpClient.get(this.ngaugeService.getMeldURL('GETALLACTIVITY'), { params: httpParams });
  }

  getAccountsList(isClusterproperty, userProperty) {
    const columnFilter = '"fields" :["id", "account", "status", "type","SID"]';
    const orderby = '"order":"account asc"';
    
    // Existing whereCondition
    const whereCondition =
      '"where":{"or":[{"and": [{"property":"' + userProperty + '"}, {"type":"Single Property"}]},' +
      '{"type":"Multiple Property"}]}';
  
    // Additional where condition for account['contact'].length > 0
    const additionalWhereCondition = '"account.contact.length > 0"';
  
    // Combining the conditions using 'and'
    const combinedWhereCondition =
      '"where":{"and": [' + whereCondition + ', ' + additionalWhereCondition + ']}';
  
    const secondwherecondition = '"where":{"SID":"' + this.authService.getSID() + '"}';
  
    // Using isClusterproperty to determine which condition to use
    const filter = isClusterproperty
      ? `{ ${combinedWhereCondition}, ${columnFilter}, ${orderby} }`
      : `{ ${secondwherecondition},${columnFilter}, ${orderby} }`;
  
    const params = { params: this.ngaugeService.getHttpParams(filter) };
  
    return this.httpClient.get(
      this.ngaugeService.getMeldURL("ACCOUNT_OPTIMIZED"),
      params
    );
  }
  
  


  getContacts(accountId) {
    const whereCondition = '"where": {"accountId":' + accountId + "}";
    // const SID = this.authService.getSID()
    const columnFilter =
      '"fields" :["id", "accountId", "firstName", "lastName", "title", "phoneNumber", "contact", "contactDetail" ]';
    const filter = `{ ${whereCondition}, ${columnFilter} }`;
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(
      this.ngaugeService.getMeldURL("CONTACT"),
      params
    );
  }

  getAllContacts() {
    const columnFilter =
      '"fields" :["id", "accountId", "firstName", "lastName", "title", "phoneNumber", "contact", "contactDetail", "SID"]';
    const filter = `{ ${columnFilter}}`;
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(
      this.ngaugeService.getMeldURL("CONTACT"),
      params
    );
  }

  getSalesActivityById(salesActivityId) {
    const includeUsers =
      '{"relation": "adminuser", "scope":{"fields":["id","firstName","lastName"]}}';
    const includeTables = '"include": [' + includeUsers + "]";
    const columnFilter =
      '"fields" :["createdBy", "salesActivityType", "startDate", "endDate", "startTime",' +
      '"endTime", "allDay", "repeatEveryDay", "priority", "assigned", "assigned", "accountId", "id",' +
      '"objective", "contactDetail", "completionDate", "completed", "result", "contact", "property"]';
    const whereCondition = '"where": {"id": ' + salesActivityId + "}";

    const filter =
      "{" +
      whereCondition +
      "," +
      columnFilter +
      "," +
      includeTables +
      "}";
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(
      this.ngaugeService.getMeldURL("SALES_ACTIVITY"),
      params
    );
  }

  getAccountSalesActivity(fromDate, toDate, property, isClusterName) {
    fromDate = DateUtil.getFormattedDate(fromDate);
    toDate = DateUtil.getFormattedDate(toDate);
    const betweenCondition =
      '{"between": ["' + fromDate + '", "' + toDate + '"]}';
    const salesActivityFields = '"fields": ["id", "salesPerson", "salesActivityType", "assigned", "property", "SID"]';
    const includeSalesActivity =
      '{"relation": "salesactivity", "scope":{' +
      salesActivityFields +
      ", " +
      this.getWhereCondition(
        isClusterName,
        "completionDate",
        betweenCondition,
        property
      ) +
      "}}";
    const groupSAFields = '"fields" : ["id","groupName", "typeOfSalesActivity", "salesPerson", "property"]';
    const whereCondition = '"where": {"salesActivityDate":' + betweenCondition + "}";
    const includeAdminUser = '"include":{"relation": "adminuser", "scope":{"fields":["id","firstName","lastName"]}}';
    const groupFields = '"fields": ["id", "groupName", "property"]';
    const includeProperty = '"where": { "property": "' + property + '"}';
    const includeGroup = !isClusterName
      ? '{"relation": "groupinfo", "scope":{' +
        groupFields +
        "," +
        ' "include":{"relation": "groupsalesactivity", "scope":{' +
        groupSAFields +
        ", " +
        whereCondition +
        "," +
        includeAdminUser +
        "}}," +
        includeProperty +
        "}}"
      : '{"relation": "groupinfo", "scope":{' +
        groupFields +
        "," +
        ' "include":{"relation": "groupsalesactivity", "scope":{' +
        groupSAFields +
        ", " +
        whereCondition +
        "," +
        includeAdminUser +
        "}}}}";
    const functionSAFields =
      '"fields": ["id", "functionName", "typeOfSalesActivity", "salesPerson", "SID"]';
    const functionFields = '"fields": ["id", "functionName", "property", "SID"]';
    const includeFunction = !isClusterName
      ? '{"relation": "accountfunction", "scope":{' +
        functionFields +
        "," +
        ' "include":{"relation": "functionsalesactivity","scope":{' +
        functionSAFields +
        "," +
        whereCondition +
        "," +
        includeAdminUser +
        "}}," +
        includeProperty +
        "}}"
      : '{"relation": "accountfunction", "scope":{' +
        functionFields +
        "," +
        ' "include":{"relation": "functionsalesactivity","scope":{' +
        functionSAFields +
        "," +
        whereCondition +
        "," +
        includeAdminUser +
        "}}}}";
    const includeTables =
      '"include" : [' +
      includeSalesActivity +
      "," +
      includeGroup +
      "," +
      includeFunction +
      "]";
    const columnFilter = '"fields": ["name","account","id","SID"]';
    const filter =
      "{" + columnFilter + "," + includeTables + "," + includeProperty + "}";
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient
      .get(this.ngaugeService.getMeldURL("ACCOUNT_OPTIMIZED"), params)
      .map((activities: any) => {
        activities.forEach((value) => {
          if (value["salesactivity"] && value["salesactivity"].length > 0) {
    value["salesactivity"].forEach((activity) => {
      activity["user"] = activity["assigned"];
    });
  }
          if (value["groupinfo"].length > 0) {
            value["groupinfo"].forEach((info) => {
              info["groupsalesactivity"].forEach((activity) => {
                console.log("Calculating Sales Productivity Count");
                activity["user"] =
                  activity["adminuser"] !== undefined
                    ? `${activity["adminuser"]["firstName"]} ${activity["adminuser"]["lastName"]}`
                    : "";
              });
            });
          }
          if (value["accountfunction"].length > 0) {
            value["accountfunction"].forEach((item) => {
              item["functionsalesactivity"].forEach((activity) => {
                console.log("Calculating Sales Productivity Count");
                activity["user"] =
                  activity["adminuser"] !== undefined
                    ? `${activity["adminuser"]["firstName"]} ${activity["adminuser"]["lastName"]}`
                    : "";
              });
            });
          }
        });
        return activities;
      });
  }

  getWhereCondition(isClusterName, field, value, property) {
    if (isClusterName) {
      return '"where": {"' + field + '":' + value + "}";
    } else {
      return (
        '"where": {"and": [{"property":"' +
        property +
        '"}, {"' +
        field +
        '":' +
        value +
        "}]}"
      );
    }
  }

  // Update / Create a Sales Activity //
  saveSalesActivity(salesActivity) {
    let sid=JSON.parse(sessionStorage.getItem('sid'))
    if (salesActivity['id'] === 0) {
      return this.httpClient.post(this.ngaugeService.getMeldURL('CREATESALESACTIVITY'), { salesactivitydetail: salesActivity, SID: sid });
    } else {
      return this.httpClient.put(this.ngaugeService.getMeldURL('UPDATESALESACTIVITY'), { salesactivitydetail: salesActivity, SID :sid });
    }
  }

  searchSalesActivities(fromDate: Date, toDate: Date, salesPersonId) {
    let httpParams = new HttpParams();
    httpParams = httpParams
      .append("startDate", DateUtil.getFormattedDate(fromDate))
      .append("endDate", DateUtil.getFormattedDate(toDate))
      .append("salesPersonId", salesPersonId)
      .append("SID", this.authService.getSID());

    return this.httpClient.get(
      this.ngaugeService.getMeldURL("SEARCH_SALES_ACTIVITY"),
      { params: httpParams }
    );
  }

  generatefutureSalesActivitiesReport(salesPerson, property) {
    const condition = '{"startDate": {"gt": "' + DateUtil.getCurrentDateFormatted(new Date()) + '"}}';
    let whereCondition = "";
    if (property === undefined) {
      if (salesPerson === "All") {
        whereCondition = '"where":' + condition;
      } else {
        whereCondition =
          '"where":{"and":[' +
          condition +
          ',{"assigned":"' +
          salesPerson +
          '"}]}';
      }
    } else {
      if (salesPerson === "All") {
        whereCondition =
          '"where":{"and":[' + condition + ',{"property":"' + property + '"}]}';
      } else {
        whereCondition =
          '"where":{"and":[' +
          condition +
          ',{"assigned":"' +
          salesPerson +
          '"},{"property":"' +
          property +
          '"}]}';
      }
    }
    const includeAccount =
      '"include": [{"relation": "account", "scope": {"fields": ["id", "account", "salesPerson"],' +
      '"include": [{"relation": "contact", "scope": {"where": { "type": "primary" }, "fields": ["id", "firstName",' +
      '"lastName", "accountId", "designation", "type"]}}]}}]';
    const whereConditionSID =
          '"where":{"SID":"' + this.authService.getSID() + '"}';
    const filter = "{" + whereCondition + "," + includeAccount + "," + whereConditionSID + "}";
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(
      this.ngaugeService.getMeldURL("SALES_ACTIVITY"),
      params
    );
  }

  getFutureSalesActivityData(salesPerson) {
    const SID = this.authService.getSID()

    let httpParams = new HttpParams();
    httpParams = httpParams.append('startDate', DateUtil.getCurrentDateFormatted(new Date()));
    httpParams = httpParams.append('SID', SID);
    httpParams = httpParams.append('assigned', salesPerson);

    return this.httpClient.get(
      this.ngaugeService.getMeldURL("GET_FUTURE_SALES_ACTIVITY"),
      { params: httpParams }
    );	
  }

  generateSalesActivitiesReport(
    fromDate: Date,
    toDate: Date,
    salesPersonId,
    type,
    property
  ) {
    const params = {
      startDate: DateUtil.getFormattedDate(fromDate),
      endDate: DateUtil.getFormattedDate(toDate),
      salesPersonId: salesPersonId,
      type,
      property,
      SID: this.authService.getSID()
    };
    return this.httpClient.post(
      this.ngaugeService.getMeldURL("GENERATE_REPORT"),
      params
    );
  }

  getCompletedTraces(whereCondition) {
    const columnFilter =
      '"fields": ["createdBy","priority","property",' +
      '"endDate", "salesActivityType", "startDate", "id", "accountId", "objective","assigned"]';
    const includeTables =
      '"include": [{"relation": "account",' +
      '"scope":{"fields": ["id", "account", "status", "type", "property"]}}]';
        const whereConditionSID =
          '"where":{"SID":"' + this.authService.getSID() + '"}';

    const filter =
      "{" + whereCondition + "," + columnFilter + "," + includeTables + "," + whereConditionSID +"}";
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(
      this.ngaugeService.getMeldURL("SALES_ACTIVITY"),
      params
    );
  }

  updateAction(values) {
    return this.httpClient.post(
      this.ngaugeService.getMeldURL("UPDATEACTIONSALESACTIVITY"),
      { salesactivitydetail: values }
    );
  }

  getSalesActivityTypes() {
    const columnFilter = '"fields": ["name", "id", "SID"]';
    const orderby = '"order":"name asc"';
    const whereSID = `"where":{"SID": "${ this.authService.getSID()}"}`;
    const filter = `{ ${columnFilter}, ${orderby}, ${whereSID} }`;
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(
      this.ngaugeService.getMeldURL("GET_SALES_ACTIVITY_TYPES"),
      params
    );
  }

  generatePendingReport(whereCondition) {
    const columnFilter =
      '"fields": [' +
      '"endDate", "salesActivityType", "startDate", "id", "accountId", "assigned", "contactDetail", "objective", "result"]';
    const contactTypePrimary = '"where": {"type": "primary"}';
    const includeContact =
      '"include": {"relation": "contact", ' +
      '"scope":{' +
      contactTypePrimary +
      "," +
      '"fields": ["id", "firstName", "lastName", "accountId", "designation"]}}';
    const includeUsers =
      '{"relation": "adminuser", "scope":{"fields":["id","firstName","lastName"]}}';
    const includeTables =
      '"include": [{"relation": "account",' +
      '"scope":{"fields": ["id", "account"], ' +
      includeContact +
      "}}]";
    const filter =
      "{" + whereCondition + "," + columnFilter + "," + includeTables + "}";
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(
      this.ngaugeService.getMeldURL("SALES_ACTIVITY"),
      params
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/sales-activity.service.ts